import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Field, Formik, FormikProps } from 'formik';
import Fields from 'components/Fields';
import { Button } from 'components/Base';
import Icons from 'components/Icons';
import Router from 'components/Router/Router';

const { useHistory, useParams } = Router;

const useStyles = makeStyles({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '1100px'
  },
  title: {
    marginBottom: '1rem',
    fontSize: '2rem',
    color: '#4D4D4D'
  },
  element: {
    backgroundColor: '#fff',
    borderRadius: '0.5rem',
    margin: '1rem 0',
    padding: '1rem',
    width: '100%',

    '& label': {
      '& span': {
        fontWeight: '500'
      }
    }
  },
  description: {
    marginLeft: '2rem',
    marginTop: '0'
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    height: '5.625rem',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 1rem'
  },
  contentSmall: {
    backgroundColor: '#fff',
    width: '100%',
    maxWidth: '39rem',
    position: 'relative'
  },
  smallTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    padding: '0 2rem'
  },
  separator: {
    width: '100%',
    height: '1px',
    backgroundColor: '#E5E5E5',
    padding: '0 1rem'
  },
  closeIcon: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    width: '1.5rem',
    height: '1.5rem',
    transform: 'translate(0, -25%)',
    cursor: 'pointer'
  },
  footerSmall: {
    width: '100%',
    display: 'flex',
    padding: '1rem',
    justifyContent: 'flex-end'
  }
});

interface Props {
  continueWithManual: () => void;
  type: 'short' | 'expanded';
  closeModal?: () => void;
  setOpenIoImport?: Function;
}

const DecisionModal = ({
  continueWithManual,
  type,
  closeModal,
  setOpenIoImport
}: Props) => {
  const classes = useStyles();
  const { portfolio } = useParams() as { portfolio: string };
  const history = useHistory();

  const onSubmit = ({
    decision
  }: {
    decision: 'manual' | 'import' | 'none';
  }) => {
    switch (decision) {
      case 'manual':
        return continueWithManual();
      case 'import':
        return !!setOpenIoImport && setOpenIoImport();
      case 'none':
        return history.push(`/${portfolio}/recommendations`);
    }
  };
  return (
    <div className={classes.container}>
      <Formik
        initialValues={{
          decision: 'manual'
        }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }: FormikProps<any>) => {
          return (
            <form className={classes.content} onSubmit={handleSubmit}>
              {type === 'expanded' ? (
                <>
                  <h2 className={classes.title}>
                    Select from one of the following options:
                  </h2>
                  <div className={classes.element}>
                    <Field
                      label="Case name"
                      name="decision"
                      component={Fields.v2.Radio}
                      options={[
                        {
                          value: 'manual',
                          label: 'Add existing policies manually'
                        }
                      ]}
                    />
                    <p className={classes.description}>
                      In order to analyse policies of your clients add them
                      manually
                    </p>
                  </div>
                  <div className={classes.element}>
                    <Field
                      label="Case name"
                      name="decision"
                      component={Fields.v2.Radio}
                      options={[
                        {
                          value: 'import',
                          label: 'Import existing policies from Intelliflo'
                        }
                      ]}
                    />
                    <p className={classes.description}>
                      In order to analyse policies of your clients connect with
                      Intelliflo.
                    </p>
                  </div>
                  <div className={classes.element}>
                    <Field
                      label="Case name"
                      name="decision"
                      component={Fields.v2.Radio}
                      options={[
                        {
                          value: 'none',
                          label: 'Continue without existing policies'
                        }
                      ]}
                    />
                  </div>
                  <footer className={classes.footer}>
                    <Button endIcon={<Icons.RightArrow />} type="submit">
                      Next
                    </Button>
                  </footer>
                </>
              ) : (
                <div className={classes.contentSmall}>
                  <h2 className={classes.smallTitle}>
                    Select from one of the following options:
                  </h2>
                  <Icons.CloseIcon
                    className={classes.closeIcon}
                    onClick={closeModal}
                  />
                  <div className={classes.separator} />
                  <div
                    className={classes.element}
                    style={{ padding: '1rem 2rem', margin: '0' }}
                  >
                    <Field
                      label="Case name"
                      name="decision"
                      component={Fields.v2.Radio}
                      options={[
                        {
                          value: 'manual',
                          label: 'Add existing policies manually'
                        }
                      ]}
                    />
                    <p className={classes.description}>
                      In order to analyse policies of your clients add them
                      manually
                    </p>
                  </div>

                  <div
                    className={classes.element}
                    style={{ padding: '0rem 2rem', margin: '0' }}
                  >
                    <Field
                      label="Case name"
                      name="decision"
                      component={Fields.v2.Radio}
                      options={[
                        {
                          value: 'import',
                          label: 'Import existing policies from Intelliflo'
                        }
                      ]}
                    />
                    <p className={classes.description}>
                      In order to analyse policies of your clients connect with
                      Intelliflo.
                    </p>
                  </div>
                  <footer className={classes.footerSmall}>
                    <Button type="submit">Confirm</Button>
                  </footer>
                </div>
              )}
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default DecisionModal;
